export const LEFT_AXES_VIEW = 'left-axes-view';
export const RIGHT_AXES_VIEW = 'right-axes-view';
